@if (configuration.includeHeaderTop) {
<div #headerTop class="header-top">
    <ul class="header-top-items">
        @if (configuration.email?.href && configuration.email?.content) {
        <li>
            <a href="mailto:{{ configuration.email.href }}">
                <fa-icon [icon]="['far', 'envelope']"></fa-icon>
                {{ configuration.email.content }}
            </a>
        </li>
        } @if (configuration.phone?.href && configuration.phone?.content) {
        <li>
            <a href="tel:{{ configuration.phone.href }}">
                <fa-icon [icon]="['fas', 'phone']"></fa-icon>
                {{ configuration.phone.content }}
            </a>
        </li>
        }
    </ul>
</div>
}
<div #headerMain class="header-main">
    @if (configuration.logo?.src) {
    <div class="header-logo">
        @if (!!configuration.logo.href) {
        <a href="{{ configuration.logo.href }}">
            <img
                src="{{ configuration.logo.src }}"
                alt="{{ configuration.logo.alt }}"
            />
        </a>
        } @if (!configuration.logo.href) {
        <img
            src="{{ configuration.logo.src }}"
            alt="{{ configuration.logo.alt }}"
        />
        }
    </div>
    } @if (checkIncludeNavItemSection('main')) {
    <ul class="header-nav-items">
        @for (item of configuration.navItems; track item) {
        <li>
            <ng-container
                *ngTemplateOutlet="navItem; context: { $implicit: item }"
            ></ng-container>
        </li>
        }
    </ul>
    } @if (checkIncludeExtraNavSection()) {
    <ul class="header-extra-nav-items">
        @for (item of configuration.extraNavItems; track item) {
        <li>
            <ng-container
                *ngTemplateOutlet="navItem; context: { $implicit: item }"
            ></ng-container>
        </li>
        }
    </ul>
    }
    <ul class="header-extra">
        @if (configuration.includeCurrencySelector) {
        <li>
            <ras-currency-selector-v2
                [configuration]="configuration.childConfigs?.currency_selector"
            >
            </ras-currency-selector-v2>
        </li>
        }
        <li class="burger-menu-li">
            <ras-burger-menu
                [configuration]="{
                    menuSelector: '.header-mobile'
                }"
            >
            </ras-burger-menu>
        </li>
    </ul>
</div>
<div #headerBottom class="header-bottom">
    @if (checkIncludeNavItemSection('bottom')) {
    <ul class="header-nav-items">
        @for (item of configuration.navItems; track item) {
        <li>
            <ng-container
                *ngTemplateOutlet="navItem; context: { $implicit: item }"
            ></ng-container>
        </li>
        }
    </ul>
    }
</div>
<div #headerMobile class="header-mobile">
    @if (configuration.navItems?.length > 0) {
    <ul class="header-mobile-items">
        @for (item of configuration.navItems; track item) {
        <li>
            <ng-container
                *ngTemplateOutlet="navItem; context: { $implicit: item }"
            ></ng-container>
        </li>
        } @for (item of configuration.extraNavItems; track item) {
        <li>
            <ng-container
                *ngTemplateOutlet="navItem; context: { $implicit: item }"
            ></ng-container>
        </li>
        }
    </ul>
    }
</div>

<ng-template #navItem let-item>
    @switch (item.type) { @case ('a') {
    <a class="header-nav-item" href="{{ item.href }}">
        {{ item.content }}
    </a>
    } @case ('a-ng') {
    <a class="header-nav-item" [routerLink]="item.routerLink">
        {{ item.content }}
    </a>
    } @case ('a-group') {
    <div
        (mouseenter)="mouseEnterGroup(item)"
        (mouseleave)="mouseLeaveGroup(item)"
        class="header-nav-item header-nav-group"
    >
        {{ item.content }}
        <div
            class="header-nav-group-items"
            [class.hide]="checkHideGroupItem(item)"
        >
            @for (nestedItem of item.children; track nestedItem) {
            <ng-container class="header-nav-group-item">
                <ng-container
                    *ngTemplateOutlet="
                        navItem;
                        context: { $implicit: nestedItem }
                    "
                ></ng-container>
            </ng-container>
            }
        </div>
    </div>
    } @default {
    <span class="header-nav-item">
        {{ item.content }}
    </span>
    } }
</ng-template>
